import { createStore } from 'zustand';

import type { ErrorStore, ShowErrorProps } from '../../types/error-context';

export const errorStore = createStore<ErrorStore>()((set) => ({
  show: false,
  message: '',
  error: undefined,
  showError: ({ message, error }: ShowErrorProps) => {
    set({
      show: Boolean(message),
      message: message ?? '',
      error,
    });
  },
  hideError: () => {
    set({ show: false, message: '', error: undefined });
  },
}));
